var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfBusinessDetailsAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.696,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AC9EE4",
    d: "M21 29.842h7.368v-16.21H21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4615D6",
    d: "M21 17.716h3.685M21 21.769h3.685M21 26.19h3.685"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#AC9EE4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 29.842h14V8.067H7zM10.842 8.067h6.316v-2.91h-6.316z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4615D6",
    d: "M10.316 13.663h7.369M10.316 19.19h7.369M10.316 24.347h7.369M4.053 30.164h26.895"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfBusinessDetailsAct);
export default __webpack_public_path__ + "static/media/af-business-details-act.fb97c474a0b6a05f7fd90e8b49b951f4.svg";
export { ForwardRef as ReactComponent };